import React from 'react'

const AddConsumer = () => {
  return (
    <div>index</div>
  )
}

export default AddConsumer